import type { Education } from '@seek/ca-myprofile-utils';

import { getVerificationStatus } from 'src/middlewares/utils';

export const getAnalyticsCustomProps = ({
  qualificationId = '',
  confirmedQualifications = [],
}: {
  qualificationId: string | undefined;
  confirmedQualifications: Education[];
}) => {
  const qualification = confirmedQualifications.find(
    (q) => q.id === qualificationId,
  );

  if (qualification) {
    return {
      verificationStatus: getVerificationStatus(qualification),
    };
  }

  return {};
};
